import DashboardYtdController from './ytd';

export default class DashboardSpoController extends DashboardYtdController {
  get monthlyGoalAmount() {
    let goalAmount = this.goal?.goalAmount;
    if (goalAmount) {
      return goalAmount / 12;
    } else {
      return undefined;
    }
  }
}
